"use client";

import { useRouterState } from "@tanstack/react-router";

import { PageBackground } from "#/components/PageBackground";
import { shouldShowPageBackground } from "#/lib/pageBackgroundRoutes";

export function PageBackgroundGate() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  if (!shouldShowPageBackground(pathname)) return null;
  return <PageBackground />;
}
